import React from 'react'
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import logo from '../../../Assets/Images/imgLogoBuyPolicyNow.png';
import { Link } from 'react-router-dom';
// css is in Home.css file

const SmallNavbar = () => {
  return (
    <Navbar className="bg-body-tertiary " sticky="top">
    <Container>
    <Link to={`${process.env.PUBLIC_URL}/`}>
      <Navbar.Brand >
      <img src={logo} className="logo-image-small" alt="logo"/>
      </Navbar.Brand>
    </Link>
      <Navbar.Toggle />
      <Navbar.Collapse className="justify-content-end">
        <Navbar.Text className='d-flex  flex-column '>
        <span >Toll Free</span>

        <span >788574467664</span>
        </Navbar.Text>
      </Navbar.Collapse>
    </Container>
  </Navbar>
  )
}

export default SmallNavbar